"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _linkFieldSrc = require("../lib/linkFieldSrc");
var _lodash = require("lodash");
var _archetypeLibrary = require("archetype-library");
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * props Component
 *
 * @param {object} props Properties used for the component
 *
 * @returns {React.ReactElement} A Step Object
 */

var Steps = props => {
  var stepObj = [];
  var url = (0, _utils.getMMDomainUrl)(props.apiUrl, false, true, true);
  var showIcon = !(0, _lodash.isEmpty)(props.icon) ? props.icon + '-black' : '';
  (0, _lodash.map)(props.items, steps => {
    var CTAList = [];
    var showContent = steps.fields.ShowSideContent.value;
    var iconPosition = steps.fields.NextIconPosition.value === 'right' ? 'R' : 'L';
    var args = {
      Title: steps.fields.Title.value,
      Description: steps.fields.Description.value,
      SecondaryDescription: steps.fields.SecondaryDescription.value
    };
    args.BackButton = {
      Label: steps.fields.BackText.value,
      Icon: steps.fields.BackIcon.value,
      Variant: steps.fields.BackVariant.value
    };
    args.NextButton = {
      Label: steps.fields.NextText.value,
      Icon: steps.fields.NextIcon.value,
      Variant: steps.fields.NextVariant.value,
      Side: iconPosition,
      HideNext: steps.fields.HideNext.value
    };
    args.RightHandButton = {
      Label: steps.fields.RightText.value,
      Href: "",
      Target: "",
      Variant: steps.fields.RightVariant.value
    };
    if (showContent) {
      (0, _lodash.map)(steps.fields.SideCTAList, sideList => {
        var {
          linkUrl,
          linkTarget
        } = (0, _linkFieldSrc.linkFieldSrc)(sideList.fields.Link.value);
        var ctalist = {
          Href: linkUrl,
          Label: sideList.fields.Text.value,
          Target: linkTarget,
          Variant: sideList.fields.ButtonType.value
        };
        CTAList.push(ctalist);
      });
      args.SideContent = {
        Title: steps.fields.SideTitle.value,
        Description: steps.fields.SideDescription.value,
        CTAList
      };
    }
    stepObj.push(args);
  });
  switch (props.type.value) {
    case 'life':
      return /*#__PURE__*/_react.default.createElement(_archetypeLibrary.LifeInsuranceWizardCalc, {
        config: {
          API_URL: url,
          HasBorder: props.showBorder,
          Icon: showIcon,
          isForcedSingleColumnLayout: props.forcedSingleColumn,
          Label: props.title,
          SecondaryStyle: props.sideBarBoxVariant,
          Steps: stepObj
        }
      });
    case 'disability':
      return /*#__PURE__*/_react.default.createElement(_archetypeLibrary.DisabilityWizardCalc, {
        config: {
          API_URL: url,
          HasBorder: props.showBorder,
          Icon: showIcon,
          isForcedSingleColumnLayout: props.forcedSingleColumn,
          Label: props.title,
          SecondaryStyle: props.sideBarBoxVariant,
          Steps: stepObj
        }
      });
    case 'retirementincome':
      return /*#__PURE__*/_react.default.createElement(_archetypeLibrary.RetirementIncomeWizardCalc, {
        config: {
          API_URL: url,
          HasBorder: props.showBorder,
          Icon: showIcon,
          isForcedSingleColumnLayout: props.forcedSingleColumn,
          Label: props.title,
          SecondaryStyle: props.sideBarBoxVariant,
          Steps: stepObj
        }
      });
    case 'college':
      return /*#__PURE__*/_react.default.createElement(_archetypeLibrary.CollegeSavingsWizardCalc, {
        config: {
          API_URL: url,
          HasBorder: props.showBorder,
          Icon: showIcon,
          isForcedSingleColumnLayout: props.forcedSingleColumn,
          Label: props.title,
          SecondaryStyle: props.sideBarBoxVariant,
          Steps: stepObj
        }
      });
    case 'businessvalue':
      return /*#__PURE__*/_react.default.createElement(_archetypeLibrary.BusinessValuationWizardCalc, {
        config: {
          API_URL: url,
          HasBorder: props.showBorder,
          Icon: showIcon,
          isForcedSingleColumnLayout: props.forcedSingleColumn,
          Label: props.title,
          SecondaryStyle: props.sideBarBoxVariant,
          Steps: stepObj
        }
      });
    case 'keyemployee':
      return /*#__PURE__*/_react.default.createElement(_archetypeLibrary.KeyEmployeeWizardCalc, {
        config: {
          API_URL: url,
          HasBorder: props.showBorder,
          Icon: showIcon,
          isForcedSingleColumnLayout: props.forcedSingleColumn,
          Label: props.title,
          SecondaryStyle: props.sideBarBoxVariant,
          Steps: stepObj
        }
      });
    case 'modal':
      return /*#__PURE__*/_react.default.createElement(_archetypeLibrary.ModalChargeCalculator, {
        config: {
          API_URL: url,
          HasBorder: props.showBorder,
          Icon: showIcon,
          isForcedSingleColumnLayout: props.forcedSingleColumn,
          Label: props.title,
          SecondaryStyle: props.sideBarBoxVariant,
          Steps: stepObj
        }
      });
    case 'reqdminimum':
      return /*#__PURE__*/_react.default.createElement(_archetypeLibrary.RequiredMinimumDistributionWizardCalc, {
        config: {
          API_URL: url,
          HasBorder: props.showBorder,
          Icon: showIcon,
          isForcedSingleColumnLayout: props.forcedSingleColumn,
          Label: props.title,
          SecondaryStyle: props.sideBarBoxVariant,
          Steps: stepObj
        }
      });
    case 'investorprofile':
      return /*#__PURE__*/_react.default.createElement(_archetypeLibrary.InvestorProfileCalculator, {
        config: {
          API_URL: url,
          HasBorder: props.showBorder,
          Icon: showIcon,
          isForcedSingleColumnLayout: props.forcedSingleColumn,
          Label: props.title,
          SecondaryStyle: props.sideBarBoxVariant,
          Steps: stepObj
        }
      });
    case 'tradvsroth':
      return /*#__PURE__*/_react.default.createElement(_archetypeLibrary.TraditionalvRothWizardCalc, {
        config: {
          API_URL: url,
          HasBorder: props.showBorder,
          Icon: showIcon,
          isForcedSingleColumnLayout: props.forcedSingleColumn,
          Label: props.title,
          SecondaryStyle: props.sideBarBoxVariant,
          Steps: stepObj
        }
      });
    case 'retirementincomegap':
      return /*#__PURE__*/_react.default.createElement(_archetypeLibrary.RetirementIncomeGapWizardCalc, {
        config: {
          API_URL: url,
          HasBorder: props.showBorder,
          Icon: showIcon,
          isForcedSingleColumnLayout: props.forcedSingleColumn,
          Label: props.title,
          SecondaryStyle: props.sideBarBoxVariant,
          Steps: stepObj
        }
      });
    case 'glwb':
      return /*#__PURE__*/_react.default.createElement(_archetypeLibrary.GuaranteedLifetimeWithdrawalBenefitWizardCalc, {
        config: {
          API_URL: url,
          HasBorder: props.showBorder,
          Icon: showIcon,
          isForcedSingleColumnLayout: props.forcedSingleColumn,
          Label: props.title,
          SecondaryStyle: props.sideBarBoxVariant,
          Steps: stepObj,
          HideNext: props.HideNext,
          CONTENT_API_CALC_PDF: '/apicalls/downloadpdf/calcpdf'
        }
      });
    default:
      return null;
  }
};
var _default = exports.default = Steps;